<template>
    <div>
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('k036') }}</div>
            <Row class="limit-line" type="flex">
                <Col flex="1">
                <Checkbox v-model="calib">{{ getTranslation('k121') }}(功能暂未开发)</Checkbox>
                </Col>
            </Row>
            <Row type="flex" class="menu-actions">
                <Col flex="1" class="flex-left">
                <Button type="info" size="small" icon="md-cloud-download" @click.native="backupExport()">{{ getTranslation('k025')
                }}</Button>&nbsp;
                <Button type="success" size="small" icon="md-cloud-upload" @click.native="backupImport()">{{ getTranslation('k026')
                    }}</Button>

                <Upload :action="importUrl" ref="backupFileUpload" name="file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :show-upload-list="false"
                    style="display: none" :on-success="successImport" :on-error="errorImport">
                </Upload>
                </Col>
            </Row>
        </Card>
    </div>
</template>
<script>
import { API_URL } from '@/constants/const';
import axios from 'axios';
import { Card, Row, Col, Button, Checkbox, Upload } from "view-design"
import { mapGetters } from 'vuex'
import { exportFile, blobToString, postJsError } from '@/util/util.js'

export default {
    name: 'SystemBackup', // 组件名称
    components: {
        Card, Row, Col, Button, Checkbox, Upload
    },
    props: {

    },
    data() {
        return {
            calib: false,
            mac: 0,
            file: null,
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        importUrl() {
            return API_URL["systemBackupImport"] + '?mac=' + this.mac;
        }
    },
    watch: {

    },

    created() {
        this.init();
    },
    methods: {
        init() {
            this.mac = this.$route.query.mac
        },
        async backupExport() {

            let url = API_URL["systemBackupExport"] + '?mac=' + this.mac + '&calib=' + this.calib;
            const response = await axios.get(url, {
                responseType: 'blob',
            });
            if (response.status == 200) {        
                const contentType = response.headers['content-type'];
                if (contentType && contentType.includes('application/json')) {
                blobToString(response.data).then(text => {
                    let msgData = JSON.parse(text);
                    if (msgData.msg) {
                    this.$Message.error(msgData.msg)
                    }
                }).catch((err) => {
                    postJsError(err)        
                    this.$Message.error(this.getTranslation('c001'));
                });
                } else {
                    exportFile(response)
                }
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }

        },
        backupImport() {
            let _this = this;
            this.$Modal.confirm({
                title: "",
                content: this.getTranslation('m073'),
                okText: this.getTranslation('b181'),
                cancelText: this.getTranslation('b182'),
                onOk: () => {
                    _this.$refs.backupFileUpload.$el.querySelector('input[type="file"]').click();
                }
            });
        },
        errorImport() {
            
            this.$Message.error(this.getTranslation('c001'));
        },
        successImport(response) {
            if (response && response.code == 200) {
                this.$Message.success(response.msg);
            } else if (response && response.msg) {
                this.$Modal.info({
                    title: this.getTranslation("m062"),
                    content: response.msg.replace(/\n/g, '<br>'),
                    okText: this.getTranslation("m063"),
                });               
            }
        },
    },
}
</script>

<style scoped>
@import url('../../../assets/style/list.css');
@import url('../../../assets/style/tab.css');
</style>